import { Box, Skeleton } from "@mui/material";
import { useAppDispatch, useAppSelector } from "helpers/hooks";
import { useEffect } from "react";
import { ShAlert } from "shared/SharedStyles/ShFeedback";
import { getCandidateCareerReport } from 'store/slices/candidate/candidate-profile-slice';

export const CandidateReport = () => {

    const { getApplicantCareerReportStatus, getApplicantCareerReportResponse, careerReport } = useAppSelector(state => state.candidate.candidateProfile);
    const { accountId } = useAppSelector((state) => state.auth.auth);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (accountId) {
            dispatch(getCandidateCareerReport({ applicantId: accountId }));
        }
    }, [accountId, dispatch])

    return (<>
        {getApplicantCareerReportStatus === 'failed' &&
            <>
                <Box marginBottom={2} width='100%'>
                    <ShAlert>
                        {getApplicantCareerReportResponse}
                    </ShAlert>
                </Box>
            </>}
        {getApplicantCareerReportStatus === 'pending' ?
            <Skeleton width='100%' height='100%' animation='wave' /> :
            <>
                <embed
                    title="Career Report"
                    src={careerReport}
                    type="application/pdf"
                    width="100%"
                    height="98%"
                />
            </>}
    </>);
}